import React, { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import cn from 'classnames';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
    id: string;
    /** Label inside the checkbox, can also contain React elements */
    label?: ReactNode;
    indeterminate?: boolean;
    children?: ReactNode;
}

/**
 * @name        a-checkbox
 * @type        atom
 *
 * @param       {string}    id                Unique ID for each checkbox
 * @param       {string}    label             Label to display
 * @param       {boolean}   checked           Select or unselect the input
 * @param       {boolean}   disabled          Whether or not the checkbox is disabled
 * @param       {boolean}   indeterminate     Wether or not the checkbox is indeterminate
 * @description
 * representation of checkboxes
 */

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props, ref) => {
    const {
        id,
        label,
        indeterminate,
        className,
        style,
        children,
        ...rest
    } = props;
    const classes = cn(
        'a-checkbox',
        { 'a-checkbox--indeterminate': indeterminate },
        className,
    );
    const idCheckbox = `checkbox-${id}`;
    return (
        <div className={classes} style={style}>
            <input id={idCheckbox} type="checkbox" ref={ref} {...rest} />
            <label htmlFor={idCheckbox}>{label ? label : children}</label>
        </div>
    );
});

Checkbox.displayName = 'Checkbox';

export { Checkbox };
